import { render, staticRenderFns } from "./BoDashboard.vue?vue&type=template&id=331e3091&scoped=true&"
import script from "./BoDashboard.vue?vue&type=script&lang=js&"
export * from "./BoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BoDashboard.vue?vue&type=style&index=0&id=331e3091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e3091",
  null
  
)

export default component.exports